<svelte:options tag="cdlc-hired-cdl-job-ad" />

<script>
  import _ from 'lodash';
  export let ad_data;
</script>

{#if ad_data}
  <div
    class="HiredCDLJobAd"
    on:click={() => {
      if (ad_data.permalink_url) {
        window.open(ad_data.permalink_url, '_blank');
      }
    }}
  >
    <div class="HiredCDLJobAd-companyLogo">
      {#if ad_data.companyLogo}
        <img src={ad_data.companyLogo} alt="Company Logo" />
      {:else}
        <img
          alt="icon"
          src="data:image/png;base64,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"
        />
      {/if}
    </div>
    <div class="HiredCDLJobAd-mainConent">
      <div class="HiredCDLJobAd-jobTitle">
        <h2>{ad_data.headline}</h2>
      </div>
      <div class="HiredCDLJobAd-subJobTitle">
        <h5>{ad_data.companyName}</h5>
        {#if ad_data.location}
          <h5 class="HiredCDLJobAd-location">- {ad_data.location}</h5>
        {/if}
      </div>
      <div class="HiredCDLJobAd-description">
        <p>
          {_.truncate(ad_data.message, { length: 200 })}
          <span>Apply Now...</span>
        </p>
      </div>
      <div class="HiredCDLJobAd-postedDate">
        <p>Posted On 3/21/2022</p>
      </div>
    </div>
  </div>
{/if}

<style src="./HiredCDLAd.scss">
</style>
